module.exports = __webpack_public_path__ + "media/images/common/logo_coopmie-70943dd562cadf1cd374d58f7ff311e4.png";